// extracted by mini-css-extract-plugin
export default {"container":"_2s6Pl","label":"_2sfNo","tooltip":"_2Bfh1"};